$(document).on('click','.b2b-login-switch-register',function(){
    $('.b2b-wrap').toggleClass('show-b2b-register');
})
$(document).on('click','.link-right-modal-b2b',function(){
    $($(this).attr('href')).modal('show');
})
$(document).on('click','.show-b2b-register .form-check-label a[href="/privacy-policy"]',function(){
    $('#policyrights').modal('show');
    return false;
})


$(document).on('click', 'a[href="#privacy-settings"]', function() {
    $('.cookie-bar').removeClass('out');
    return false;
});